const months = [   
    {
        "id": 1,
        "code": "January",
        "shortName": "Ene",
        "longName": "Enero",
    }, 
    {
        "id": 2,
        "code": "February",
        "shortName": "Feb",
        "longName": "Febrero",
    }, 
    {
        "id": 3,
        "code": "March",
        "shortName": "Mar",
        "longName": "Marzo",
    }, 
    {
        "id": 4,
        "code": "April",
        "shortName": "Abr",
        "longName": "Abril",
    }, 
    {
        "id": 5,
        "code": "May",
        "shortName": "May",
        "longName": "Mayo",
    }, 
    {
        "id": 6,
        "code": "June",
        "shortName": "Jun",
        "longName": "Junio",
    }, 
    {
        "id": 7,
        "code": "July",
        "shortName": "Jul",
        "longName": "Julio",
    },
    {
        "id": 8,
        "code": "August",
        "shortName": "Ago",
        "longName": "Agosto",
    },
    {
        "id": 9,
        "code": "September",
        "shortName": "Sep",
        "longName": "Septiembre",
    },
    {
        "id": 10,
        "code": "October",
        "shortName": "Oct",
        "longName": "Octubre",
    },
    {
        "id": 11,
        "code": "November",
        "shortName": "Nov",
        "longName": "Noviembre",
    },
    {
        "id": 12,
        "code": "December",
        "shortName": "Dic",
        "longName": "Diciembre",
    },
]

export { months }